export function identitySelector<T>(x: T): T {
  return x;
}
